module.exports = __webpack_public_path__ + "img/mind_link_icon1.dc914635.png";